// Mirror of /app/backend/industries.py — keep slugs in sync.
// Icons resolved via Phosphor at usage site to avoid heavy imports here.

export const INDUSTRIES = [
  {
    slug: "general",
    label: "General",
    kpiLabel: "Project Health",
    short: "Any project, any team",
    valueProp: "Run any project through ARISSAI's six lenses.",
    longDesc:
      "The default profile. Use this if your work spans multiple domains or doesn't fit a single industry — ARISSAI's six lenses still deliver assumption validation, risk forecasting, root-cause detection, and PMO briefs without industry framing.",
    accent: "#09090B",
    icon: "Cube",
  },
  {
    slug: "technology_saas",
    label: "Technology & SaaS",
    kpiLabel: "Release Confidence",
    short: "Ship roadmaps with confidence",
    valueProp:
      "Validate product assumptions and forecast launch risk before each release.",
    longDesc:
      "For product, engineering, and platform leaders shipping software. ARISSAI's lenses adapt to product-management vocabulary — release cycles, technical debt, scope creep, churn, platform reliability, engineering velocity — so every roadmap decision is defensible.",
    accent: "#0020F5",
    icon: "Cpu",
  },
  {
    slug: "consulting_pmo",
    label: "Consulting & PMO Services",
    kpiLabel: "Engagement Health",
    short: "Standardise across every client",
    valueProp:
      "Standardise risk, issue & stakeholder tracking across every client engagement.",
    longDesc:
      "For consulting firms, embedded PMOs, and delivery agencies. ARISSAI brings client-engagement framing to every lens — scope-to-fee alignment, deliverable quality, billing milestones, stakeholder satisfaction — and ships steering-committee-ready briefs each Monday.",
    accent: "#7C3AED",
    icon: "Briefcase",
  },
  {
    slug: "transformation_strategy",
    label: "Transformation & Strategy",
    kpiLabel: "Program Confidence",
    short: "Multi-year programs, quantified",
    valueProp:
      "Quantify execution risk on multi-year programs for steering committees.",
    longDesc:
      "For large transformation programs, M&A integrations, and enterprise strategy offices. ARISSAI surfaces change-management risk, benefit-realisation gaps, cross-functional dependencies, and executive-sponsorship strength — exactly the inputs your steering committee needs.",
    accent: "#FF9500",
    icon: "Strategy",
  },
  {
    slug: "healthcare_ops",
    label: "Healthcare Operations",
    kpiLabel: "Operational Risk Index",
    short: "Auditable risk for care delivery",
    valueProp:
      "Govern complex care-delivery programs with auditable risk & issue tracking.",
    longDesc:
      "For hospital operations, regional health authorities, and care-delivery transformation teams. ARISSAI frames every analysis around operational risk, patient-flow continuity, staffing, governance, and auditability — never clinical diagnosis, always operational recommendations.",
    accent: "#00C7BE",
    icon: "Heartbeat",
  },
  {
    slug: "finance_fpa",
    label: "Enterprise Finance & FP&A",
    kpiLabel: "Portfolio Confidence",
    short: "Risk-aware capital planning",
    valueProp:
      "Surface portfolio execution risk for finance & capital planning reviews.",
    longDesc:
      "For CFO offices, FP&A leads, and corporate development teams. ARISSAI translates project risk into language finance speaks — forecast accuracy, capital allocation, portfolio prioritisation, budget variance, run-rate — so capital approval decks finally match delivery reality.",
    accent: "#16A34A",
    icon: "ChartBar",
  },
  {
    slug: "engineering",
    label: "Engineering",
    kpiLabel: "Delivery Confidence",
    short: "Capital-works risk, decoded",
    valueProp:
      "Surface schedule, safety, and supplier risk on capital engineering projects.",
    longDesc:
      "For civil, mechanical, electrical, and industrial engineering teams delivering capital programs. ARISSAI tracks schedule slippage, supplier performance, safety incidents, design changes, and commissioning readiness — exactly the risks that cause cost overruns on major projects.",
    accent: "#0EA5E9",
    icon: "Wrench",
  },
  {
    slug: "law_firm",
    label: "Law Firm",
    kpiLabel: "Matter Confidence",
    short: "Matter risk & deadline radar",
    valueProp:
      "Track matter risk, deadlines, and commercial exposure across the practice.",
    longDesc:
      "For partners, practice managers, and in-house legal teams. ARISSAI keeps an eye on matter-budget burn, limitation deadlines, discovery readiness, and partner-in-charge accountability — without giving legal advice. Operational visibility, not opinion.",
    accent: "#A855F7",
    icon: "Scales",
  },
  {
    slug: "construction",
    label: "Construction",
    kpiLabel: "Schedule Confidence",
    short: "Site, schedule & safety radar",
    valueProp:
      "Track schedule, safety, and subcontractor risk across active construction sites.",
    longDesc:
      "For general contractors, project superintendents, and construction programme leads. ARISSAI surfaces schedule slippage, subcontractor performance, safety/HSE incidents, RFI and change-order throughput, supply-chain delays, and commissioning readiness — keeping float and the critical path honest.",
    accent: "#EAB308",
    icon: "HardHat",
  },
];

export const INDUSTRY_BY_SLUG = INDUSTRIES.reduce((acc, i) => {
  acc[i.slug] = i;
  return acc;
}, {});

export const getIndustry = (slug) =>
  INDUSTRY_BY_SLUG[slug] || INDUSTRY_BY_SLUG.general;
